import apiClient from './axios';

export const departmentsApi = {
  // Отримати всі департаменти (для авторизованих користувачів)
  getAllDepartments: () => {
    return apiClient.get('/departments');
  },
  
  // Отримати публічні департаменти (для реєстрації)
  getPublicDepartments: () => {
    return apiClient.get('/public/departments');
  },
  
  // Отримати департамент за ID
  getDepartment: (id) => {
    return apiClient.get(`/departments/${id}`);
  },
  
  // Пошук департаментів
  searchDepartments: (query) => {
    return apiClient.get(`/departments/search?query=${encodeURIComponent(query || '')}`);
  },
  
  // Створення департаменту (для адміністратора)
  createDepartment: (departmentData) => {
    return apiClient.post('/departments', departmentData);
  },
  
  // Оновлення департаменту (для адміністратора)
  updateDepartment: (id, departmentData) => {
    return apiClient.put(`/departments/${id}`, departmentData);
  },
  
  // Видалення департаменту (для адміністратора)
  deleteDepartment: (id) => {
    return apiClient.delete(`/departments/${id}`);
  },
  
  // Отримати статистику департаменту
  getDepartmentStats: (id) => {
    return apiClient.get(`/departments/${id}/stats`);
  },
  
  // Отримати користувачів департаменту
  getDepartmentUsers: (id) => {
    return apiClient.get(`/departments/${id}/users`);
  }
};

export default departmentsApi;